var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VPopper from '../Popper/Popper';
import Spinner from '../Progress/Spinner/Spinner.vue';
import WithRender from './AutoSelect.html';
// FIELDS
export const OPTIONS = 'options';
export const VALUE = 'value';
// TODO: PENDING WORK ITEMS
// 1. Support for OnEnter key
// 2. Debounce effect
let AutoSelect = class AutoSelect extends Vue {
    // TODO: PENDING WORK ITEMS
    // 1. Support for OnEnter key
    // 2. Debounce effect
    constructor() {
        super(...arguments);
        this.textInput = '';
    }
    get showEmpty() {
        // When to show no data found
        return this.options.length === 0 && !this.loading && !this.disabled;
    }
    get popperContentClass() {
        return {
            'popper--no-content': (!this.textInput || this.textInput.length === 0) && this.options.length === 0,
            'autoselect--error': this.error
        };
    }
    /**
     * Don't remove this method: Used by `MutiSelect` component which is developed on-top off `AutoSelect`.
     * @param focus - When you want input box to be focused programatically
     */
    resetInput(focus = false) {
        this.textInput = '';
        if (focus) {
            this.$refs.input.focus();
        }
    }
    showOptions() {
        this.$refs.popper.show();
    }
    onKeyTab() {
        this.$nextTick()
            .then(() => this.$refs.popper.hide());
    }
    onKeyDown(event) {
        this.$nextTick().then(() => {
            if (this.options.length > 0) {
                const option = this.$refs.optionLabel[0];
                option.focus();
            }
        });
    }
    onOptionsKeyDown(event, option) {
        const keycode = event.keyCode || event.which;
        event.preventDefault();
        this.$nextTick().then(() => {
            if (keycode === 40 /* DOWN */ && event.target.nextElementSibling) {
                event.target.nextElementSibling.focus();
            }
            if (keycode === 38 /* UP */ && event.target.previousElementSibling) {
                event.target.previousElementSibling.focus();
            }
            if (keycode === 13 /* ENTER */) {
                this.onOptionSelect(option);
                this.$refs.popper.hide();
            }
            if (keycode === 9 /* TAB */) {
                this.$refs.popper.hide();
            }
            return false;
        });
    }
    onBlur() {
        this.onValue();
        this.$emit('blur');
    }
    onFocus() {
        this.showOptions();
        this.$emit('focus');
    }
    mounted() {
        this.onValue();
    }
    /**
     * Get callled whenever user play with input box.
     */
    onInput() {
        this.$emit('search', this.textInput);
    }
    /**
     * When user click on select option this method gets called with that option.
     * @param option - Selected option from select dropdown
     */
    onOptionSelect(option) {
        if (this.value !== option) {
            this.$emit('input', option);
        }
    }
    onOptions() {
        if (this.$refs.popper.isVisible) {
            this.$refs.popper.show();
        }
    }
    onValue() {
        if (this.value) {
            this.textInput = this.toText(this.value);
        }
    }
};
_a = VALUE, _b = OPTIONS;
__decorate([
    Prop({ default: 'Type to search' }),
    __metadata("design:type", String)
], AutoSelect.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AutoSelect.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AutoSelect.prototype, "error", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], AutoSelect.prototype, "loading", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], AutoSelect.prototype, _a, void 0);
__decorate([
    Prop({ default: () => (val) => val.label }),
    __metadata("design:type", Function)
], AutoSelect.prototype, "toText", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], AutoSelect.prototype, _b, void 0);
__decorate([
    Watch(OPTIONS),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AutoSelect.prototype, "onOptions", null);
__decorate([
    Watch(VALUE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AutoSelect.prototype, "onValue", null);
AutoSelect = __decorate([
    WithRender,
    Component({
        components: {
            popper: VPopper,
            spinner: Spinner
        }
    })
], AutoSelect);
export default AutoSelect;
//# sourceMappingURL=AutoSelect.js.map